import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import TextHeadline2 from "../../textComponents/TextHeadline2";
import TextBody from "../../textComponents/TextBody";
import TextCallout2 from "../../textComponents/TextCallout2";
import Button from "../../Button";
import SchibstedLogo from "../../SchibstedLogo";
import VendLogo from "../../VendLogo";
var Wrapper = styled.div.withConfig({
  displayName: "InfoPage__Wrapper",
  componentId: "sc-1wbw6oe-0"
})(["display:flex;align-items:center;justify-content:center;flex-direction:column;height:100%;padding-top:70px;padding-bottom:70px;width:100%;box-sizing:border-box;"]);
var TextWrapper = styled.div.withConfig({
  displayName: "InfoPage__TextWrapper",
  componentId: "sc-1wbw6oe-1"
})(["text-align:center;max-width:400px;padding-left:10px;padding-right:10px;margin-bottom:16px;"]);
var Headline = styled(TextHeadline2).withConfig({
  displayName: "InfoPage__Headline",
  componentId: "sc-1wbw6oe-2"
})(["margin:32px 0 16px 0;"]);
var ButtonInfoPage = styled(Button).withConfig({
  displayName: "InfoPage__ButtonInfoPage",
  componentId: "sc-1wbw6oe-3"
})(["width:400px;max-width:100%;"]);
var BottomText = styled(TextCallout2).withConfig({
  displayName: "InfoPage__BottomText",
  componentId: "sc-1wbw6oe-4"
})(["margin:16px 0 8px;padding:0px 10px;"]);
/**
 * Layout component that can be used for login page, error pages and more.
 */

var InfoPage = function InfoPage(_ref) {
  var icon = _ref.icon,
      headline = _ref.headline,
      infoText = _ref.infoText,
      buttonText = _ref.buttonText,
      buttonOnClick = _ref.buttonOnClick,
      style = _ref.style,
      className = _ref.className,
      _ref$schibstedInfo = _ref.schibstedInfo,
      schibstedInfo = _ref$schibstedInfo === void 0 ? false : _ref$schibstedInfo,
      _ref$vendInfo = _ref.vendInfo,
      vendInfo = _ref$vendInfo === void 0 ? false : _ref$vendInfo;
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    style: style
  }, icon, /*#__PURE__*/React.createElement(TextWrapper, null, /*#__PURE__*/React.createElement(Headline, null, headline), /*#__PURE__*/React.createElement(TextBody, null, infoText)), /*#__PURE__*/React.createElement(ButtonInfoPage, {
    size: "medium",
    type: "primary",
    onClick: buttonOnClick
  }, buttonText), schibstedInfo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomText, null, "Blocket \xE4r en del av"), /*#__PURE__*/React.createElement(SchibstedLogo, {
    width: 80
  })), vendInfo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomText, {
    style: {
      color: '#62605F'
    }
  }, "Blocket \xE4r en del av"), /*#__PURE__*/React.createElement(VendLogo, null)));
};

InfoPage.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * icon component that will be displayed on the infopage
   */
  icon: PropTypes.node.isRequired,

  /**
   * Headline text
   */
  headline: PropTypes.string.isRequired,

  /**
   * Information text
   */
  infoText: PropTypes.string.isRequired,

  /**
   * Text on button
   */
  buttonText: PropTypes.string.isRequired,

  /**
   * Optional callback to run on the click event
   */
  buttonOnClick: PropTypes.func.isRequired,

  /**
   * (Deprecated) Optional, needed when used as a LoginPrompt page.
   */
  schibstedInfo: PropTypes.bool,

  /**
   * Override or extend the default styles.
   */
  style: PropTypes.object,
  className: PropTypes.string,
  // Displays Vend logo with info.
  vendInfo: PropTypes.bool
} : {};
export default InfoPage;
//# sourceMappingURL=InfoPage.js.map